import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import LatestInjurySummary from "./LatestInjurySummary";

export default function InjuryDetail({ caseId }) {
  const { injuries } = useLoaderData();
  const [injuryData, setInjuryData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setInjuryData(injuries?.length > 0 ? injuries[0] : []);
    setLoading(false);
  }, [injuries]);

  if (loading) {
    return <CircularProgress color="secondary" />;
  }

  return (
    <div>
      <LatestInjurySummary injury={injuryData} casePk={caseId} />
    </div>
  );
}
